<template>
  <div>
    <el-form>
      <el-form-item :label="$t('integration.ir_time')">
        <el-date-picker
          style="width:280px;margin-right: 5px;"
          v-model="time"
          type="datetimerange"
          :range-separator="$t('public.to')"
          :start-placeholder="$t('public.start_date')"
          :end-placeholder="$t('public.end_date')"
          value-format="timestamp"
          @change="changeTime"
        >
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="getListFn"></el-button>
        <el-button icon="el-icon-refresh" @click="resetCondition"></el-button>
      </el-form-item>
    </el-form>

    <template v-if='recordList.length'>
      <el-row class="mb-10">
        <el-col :span='10'>{{ $t('integration.ir_causes') }}</el-col>
        <el-col :span='10'>{{ $t('integration.ir_process_time') }}</el-col>
        <el-col :span='4' style="text-align: right">{{ $t('public.handler') }}</el-col>
      </el-row>
      <div style='height: 160px;overflow-y:auto;'>
        <div class=' mb-10' v-for='item in recordList' :key='item.id'>
          <el-tooltip class="item" effect="dark" :content="item.remark || $t('integration.no_comment_information')" placement="top">
            <el-row>
              <el-col :span='10'>
                <div class='ellipsis'>
                  <Tooltip :text='item.reasonText' style='width: 300px;'>
                    <span>{{ item.reasonText }}</span>
                  </Tooltip>
                </div>
              </el-col>

              <el-col :span='10'>
                <div style='white-space: nowrap;' class='mr-5'>
                  {{ $timetransition(item.processTime) }}
                </div>
              </el-col>


              <el-col :span='4'>
                <div style='white-space: nowrap;text-align: right'>
                  {{ item.processor }}
                  <!-- <i class='el-icon-document cursor-pointer'
                    :title="item.remark || $t('integration.no_comment_information')"></i> -->
                </div>
              </el-col>
            </el-row>
          </el-tooltip>
        </div>

      </div>

      <div class='uk-flex uk-flex-right'>
        <Pagination class='pagination' :total='total' :background='false'
                    :iDisplayLength='SearchForm.iDisplayLength' layout='prev, pager, next'
                    :page.sync='SearchForm.iDisplayStart' :limit.sync='SearchForm.iDisplayLength'
                    @pagination='getListFn'>
        </Pagination>
      </div>
    </template>
    <template v-else>
      <el-empty :image-size='100'></el-empty>
    </template>
  </div>
</template>

<script>
import { getExHandleRecordPage } from '@/api/modules/abnormal'
import Tooltip from '@/pages/system/resource/components/tooltip.vue'

export default {
  props: ['exId'],
  components: {
    Tooltip
  },
  data () {
    return {
      SearchForm: {
        iDisplayStart: 0,
        iDisplayLength: 5,
        exId: '',
        to: null,
        from: null
      },
      recordList: [],
      total: 0,
      time: []
    }
  },
  watch: {
    exId: {
      handler () {
        this.SearchForm.exId = this.exId
        this.getListFn()
      },
      immediate: true
    }
  },
  methods: {
    getListFn () {
      getExHandleRecordPage(this.SearchForm).then(({
        result,
        pageInfo
      }) => {
        this.total = pageInfo.total

        this.recordList = result
      })
    },
    changeTime(e){
      console.log(e)
      console.log(this.time)
      this.SearchForm.to = this.time ? this.time[0] : null
      this.SearchForm.from = this.time ? this.time[1] : null
    },
    resetCondition () {
      this.SearchForm.iDisplayStart = 0
      this.SearchForm.iDisplayLength = 5
      this.SearchForm.to = null
      this.SearchForm.from = null
      this.time = []
      this.getListFn()
    },
  }
}
</script>
